import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ClientsList from "../../components/admin-component/clients/ClientsList";
import Caption from "../../components/baseui/Caption";
import {
  clientSelector,
  getClients,
  resetClient,
} from "../../redux/clientSlice";
import { Icon } from "@iconify/react";
import SearchField from "../../components/layouts/SearchField";
import { openClientModal } from "../../redux/modalSlice";
import { pageSizeSelector } from "../../redux/surveySlice";
const Clients = ({ text }) => {
  const dispatch = useDispatch();
  const pageSize = useSelector(pageSizeSelector);
  const { allClients } = useSelector(clientSelector);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    getAllClients(pageSize, 1);
  }, []);

  const getAllClients = (pageSize, pageNum) => {
    dispatch(getClients({ pageSize, pageNum, searchText }));
  };

  const openModal = () => {
    dispatch(resetClient());
    dispatch(openClientModal());
  };

  return (
    <div className="main-dashboard">
      <div className="mainWrapper">
        <div className="contentMain">
          <div className="pageTitle">
            <Row className="align-items-center">
              <Col lg="6">
                <Caption heading1="Clients" />
              </Col>
              <Col lg="6">
                <div className="filterSearch ms-auto justify-content-end">
                  <SearchField onChange={setSearchText} text={text} />
                  {/*  <BtnGroup
                  classes="btn cta-group cta-primary"
                  btnText="Add new"
                  icon={<Icon icon="ant-design:plus-outlined" />}
                />
                */}
                  <button
                    className="btn cta-primary"
                    onClick={() => openModal()}
                  >
                    <span>Add New</span>
                    <i className="ms-2">
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 3.1665L8 13.8332"
                          stroke="white"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13.3333 8.5L2.66663 8.5"
                          stroke="white"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </i>
                  </button>
                </div>
              </Col>
            </Row>
          </div>
          <ClientsList
            text={searchText}
            setSearchText={(e) => setSearchText(e)}
            clients={allClients}
            getClients={getAllClients}
          />
        </div>
      </div>
    </div>
  );
};

export default Clients;
